import ReportDownloadContainer from '@app/components/reports/components/report-download-container';
import useGeneratePdf from '@app/components/reports/hooks/use-generate-pdf';
import { useCCFReportResult } from './ccf-report-result-context';
import { useCompanyReportSections } from './company-report-sections';
import { useCCFFormattedReportSections } from './company-report-utils';
import CCFReportIntro from './pages/ccf-report-intro';

export default function CCFReportDownload() {
  const { result, resultStatus } = useCCFReportResult();
  const reportSections = useCompanyReportSections(result?.reportUuid);
  const formattedData = useCCFFormattedReportSections(reportSections, result);
  const { contentRef, status: downloadStatus } = useGeneratePdf(
    result ? result.title : undefined
  );

  return (
    <ReportDownloadContainer
      contentRef={contentRef}
      status={resultStatus}
      sections={formattedData}
      Intro={CCFReportIntro}
      downloadStatus={downloadStatus}
    />
  );
}
